import { axiosNode } from '../config/axiosConfig';
import { alertErrorResponse } from '../utils/alertResponseHttpUtil';

const RUTA_TIPOS_CONTRATO = 'tipo-contratos';

export default {
  async buscarTodos() {
    try {
      const response = await axiosNode.get(RUTA_TIPOS_CONTRATO);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async buscarTodosConRol(token, rol) {
    try {
      const response = await axiosNode.get(RUTA_TIPOS_CONTRATO, {
        headers: {
          rol: JSON.stringify(rol),
          Token: token,
        },
      });
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },
};
